import { api } from "./api";
import ShowNotifications from "../helper/ShowNotifications";

class TestimonialApi {
  getTestimonials = async (params = {}) => {
    try {
      const response = await api.get("/testimonial", { params });
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      return { status: false, response: error?.response?.data || error };
    }
  };

  saveTestimonial = async (data) => {
    try {
      const response = await api.post("/testimonial", data);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Failed to add testimonial";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };

  updateTestimonial = async (id, data) => {
    try {
      const response = await api.put(`/testimonial/${id}`, data);
      if (response.status === 200 || response.status === 201) {
        ShowNotifications.showAlertNotification("Testimonial Updated Successfully", true);
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Failed to update testimonial";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };

  deleteTestimonial = async (id) => {
    try {
      const response = await api.delete(`/testimonial/${id}`);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Failed to delete testimonial";
      ShowNotifications.showAlertNotification(errorMessage, false);
      return { status: false, response: error?.response?.data || error };
    }
  };
}

const testimonialApi = new TestimonialApi();
export default testimonialApi;

export const {
  getTestimonials,
  saveTestimonial,
  updateTestimonial,
  deleteTestimonial,
} = testimonialApi;
